var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.92662H10M3.25 1.92662C4.43268 0.691127 6.56732 0.691127 7.75 1.92662M3.25 12H7.75C8.57845 12 9.25 11.3987 9.25 10.6569V4.61285C9.25 4.24197 8.91422 3.9413 8.5 3.9413H2.5C2.08579 3.9413 1.75 4.24197 1.75 4.61285V10.6569C1.75 11.3987 2.42157 12 3.25 12Z",
    stroke: "#FF0C0C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.92662H10M3.25 1.92662C4.43268 0.691127 6.56732 0.691127 7.75 1.92662M3.25 12H7.75C8.57845 12 9.25 11.3987 9.25 10.6569V4.61285C9.25 4.24197 8.91422 3.9413 8.5 3.9413H2.5C2.08579 3.9413 1.75 4.24197 1.75 4.61285V10.6569C1.75 11.3987 2.42157 12 3.25 12Z",
    stroke: "#FF0C0C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.b3c43e8be29e520ddb694c24c2df4338.svg";
export { ForwardRef as ReactComponent };